const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '招标文件',
        },
    },
    {
        component: 'ZlmFileDetail',
        options: {
            data: [],
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '其他附件',
        },
    },
    {
        component: 'ZlmFileDetail',
        options: {
            data: [],
        },
    },
]

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        // TODO 暂没有接口
        getData() {
            // this.$request.post(`/transformToAfter/app/track/zbggOverview`, {
            //     bdGuid: this.$route.query.id,
            // }, { showLoading: true }).then((res) => {
            //     this.getGGBdList(res.data.ggGuid)
            //     this.config[1].options.data = {
            //         '项目名称': res.data.gcName,
            //         '项目编号': '',
            //         '项目类型': getProjectTypeName(res.data.xmLeiXing),
            //         '采购方式': getPurchaseTypeName(res.data.zhaoBiaoFangShi),
            //         '行业分类': res.data.hangYeFenLei,
            //         '报价方式': '',
            //         '项目概况': '',
            //         '基本要求': '',
            //     }
            //     this.config[3].options.data = {
            //         '公告名称': res.data.ggName,
            //         '公告发布媒体': '',
            //         '公告开始时间': this.$util.timeFormatter(res.data.ggStartTime),
            //         '公告附件': '',
            //     }
            // })
        },
    },
}

module.exports = {
    config,
    mixin,
}
